export {default} from "./thirdSlide";
